import SbxToast from "./sbx-toast.vue";

window.Vue.createApp({
    components: {
        SbxToast,
    },
}).mount("#toast-container");
